<template>
  <div class="summation full-width full-height">
    <div class="summation-label">{{ settings.label || 'Value' }}</div>
    <div class="d-flex flex-fill">
      <div class="flex-grow-1 summation-value">
        <span v-if="isMoney">
          {{ settings.value || '0' | money(prefix) }}
        </span>
        <span v-else>
          {{ prefix }}{{ settings.value || '0' }} {{ settings.suffix }}
        </span>
      </div>
      <div class="summation-compare" v-if="settings.showComparison">
        <div class="full-width text-center font-size-lg comparison-arrow">
          <span v-if="comparison > 0" class="text-success"
            ><v-icon>mdi-menu-up</v-icon></span
          >
          <span v-else-if="comparison < 0" class="text-danger"
            ><v-icon>mdi-menu-down</v-icon></span
          >
        </div>
        <div class="summation-prev-value">{{ comparison }}%</div>
      </div>
    </div>
    <div class="summation-desc" v-if="settings.description">
      {{settings.description}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BwSummation',
  components: {},
  props: {
    settings: {
      type: Object,
      required: true
    },
    partner: {
        type: Object,
        required: false
    },
  },
  data: () => {
    return {}
  },
  methods: {},
  async mounted() {},
  computed: {
    comparison() {
      let c =
        Math.round(
          (((this.settings.value || 0) - (this.settings.previousValue || 0)) /
            (this.settings.previousValue || 0)) *
            10000
        ) / 100
      if (c === Infinity) c = 0
      return isNaN(c) ? 0 : c
    },
    isMoney() {
      return this.settings.isMoney || false;
    },
    prefix() {
        if(this.partner && this.partner.currencyPrefix && this.isMoney) {
            return this.partner.currencyPrefix
        } 
        return this.settings.valuePrefix;
    },
     
  }
}
</script>

<style lang="scss" scoped>
	.summation {
	  background-color: white;
	  min-height: 150px;
	  border: 1px solid #ddd;
	  margin: 8px;
	  padding: 10px;
	  // min-width: 300px;
	}
	
	.summation-label {
	  font-size: 20px;
	  font-weight: 400;
	}
	
	.summation-value {
	  font-size: 35px;
	  font-weight: 700;
	}
	
	.summation-desc {
	  margin-top:5px;
	  font-size: 14px;
	}

	.text-danger {
		color: #e88475
	}
	.text-success {
		color: #73bfa1
	}
	.full-height {
		height: 100%;
	}
</style>
